import React from "react";
import './clicker-list.scss';
import AddClickerSet from "./add-clicker-set/add-clicker-set";
import SchoolApi from "../../apis/school";
import PaginationComponent from "../common/cw-pagination/cw-pagination-v2";
import AddClickerId from "./add-clicker-id-to-set/add-clicker-id";
import Loading from "../common/loading/loading";
import { getImageSource } from "../../utility/image-source";
import { Constants, ImageConstants } from "../../constants/constants";

class ClickerList extends React.Component {

    state = {
        showAddClickerSet: false,
        showAddClickerId: false,
        schools: [],
        filter: {},
        schoolIndex: -1,
        clickerInfo: []
    }

    limit = 10
    currentPage = 1
    mapClickerSetToSchoolId = {}


    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.getSchools()
    }

    getSchools(filters = {}) {
        let payload = { ...filters }
        if (!payload.limit) payload.limit = this.limit
        if (!payload.page) payload.page = this.currentPage


        this.currentPage = payload.page
        if (this.currentPage === 1) this.startIndex = 1

        payload.clickerExist = true

        SchoolApi.getSchoolWithPagination(payload).then(response => {
            this.mapClickerSetToSchoolId = {}
            for (let i = 0; i < response.response.length; i++) {
                let clicker = response.response[i].clicker
                console.log(clicker)

                for (let key in clicker.setList) {
                    let setItem = clicker.setList[key]
                    if (!this.mapClickerSetToSchoolId[response.response[i].schoolCode]) {
                        this.mapClickerSetToSchoolId[response.response[i].schoolCode] = [setItem]
                    } else {
                        this.mapClickerSetToSchoolId[response.response[i].schoolCode].push(setItem)
                    }
                }
            }
            this.setState({ schools: response.response, meta: response.meta })

        }).catch(err => {
            console.log("Error", err)
        })
    }



    onClickAddClickerSet() {
        this.setState({ showAddClickerSet: true })
    }

    hideAddClickerSet() {
        this.setState({ showAddClickerSet: false }, () => {
            this.getSchools()
        })
    }

    onPageSelected(page, startIndex) {

        this.currentPage = page;
        this.startIndex = startIndex

        this.getSchools(this.state.filter);
    }

    showAddClickerIdScreen(schoolName, schoolId, setItem, schoolIndex) {
        // console.log(setItem)
        this.setState({ selectedSchoolName: schoolName, selectedSchoolId: schoolId, selectedSet: setItem, showAddClickerId: true, schoolIndex })
    }

    hideAddClickerIdScreen() {
        this.setState({ showAddClickerId: false, selectedSchoolName: '', selectedSet: {} })
    }

    getSetList(schoolId, schoolName, schoolIndex) {

        console.log(this.mapClickerSetToSchoolId)

        let setList = this.mapClickerSetToSchoolId[schoolId]

        if (setList.length) {
            return (
                <div className="">
                    {
                        setList.map((item, index) => (
                            <div className="mb-1">
                                <span className="set-names cursor-pointer" onClick={() => this.showAddClickerIdScreen(schoolName, schoolId, item, schoolIndex)}>{item.setName} - {item.clickerCount} </span>
                                    
                            </div>
                        ))
                    }
                </div>
            )
        }

        return (
            <div className="d-flex">
                No Set List
            </div>
        )
    }

    getSetListForTesting(schoolId, schoolName, schoolIndex) {

        console.log(this.mapClickerSetToSchoolId)

        let setList = this.mapClickerSetToSchoolId[schoolId]

        if (setList.length) {
            return (
                <div className="">
                    {
                        setList.map((item, index) => (
                            <div className="mb-1">
                                
                                    <img className="status-image ml-1" src={getImageSource(item.allStudentClickerKeysTestDone ?  ImageConstants.CORRECT : ImageConstants.WRONG)} />
                                   
                            </div>
                        ))
                    }
                </div>
            )
        }

        return (
            <div className="d-flex">
                No Set List
            </div>
        )
    }


    addClickerIdToSet(selectedSet) {
        console.log(selectedSet)
        let payload = {
            schoolCode: this.state.selectedSchoolId,
            selectedSet: selectedSet
        }

        SchoolApi.updateClickerSet(payload).then(res => {
            console.log(res)
            this.hideAddClickerIdScreen()
        }).catch(err => {
            console.log(err)
        })
    }

    onChangeHandler(e, key) {
        let value = e.target.value
        let filter = this.state.filter
        filter[key] = value
        this.setState({ filter }, () => {
            if (!value || value.length >= 3) {
                this.getSchools({ ...filter, page: 1 })
            }
        })
    }

    toggleFilters = () => {
        this.setState({ showFilters: !this.state.showFilters })
    }

    onClickClear() {
        this.setState({ filter: {}, studentDeviceMacId: '', teacherDeviceMacId: '', reload: true }, () => {
            this.setState({ reload: false })
        })
    }

    onClickGo(data = {}, type) {

        if (!data.id && !this.state.teacherDeviceMacId && !this.state.studentDeviceMacId) return;

        let payload = {
        }

        if (this.state.studentDeviceMacId) {
            payload.studentDeviceMacId = data.id || this.state.studentDeviceMacId
        }

        if (this.state.teacherDeviceMacId) {
            payload.teacherDeviceMacId = data.id || this.state.teacherDeviceMacId
        }

        SchoolApi.getClickerInfo(payload).then(res => {

            this.setState({ clickerInfo: res.response })

        }).catch(err => {
            console.log(err)
        })
    }

    setClickerType(e, type) {
        this.setState({ clickerType: type, clickerInfo: [] }, () => {
            if (this.state.isListening) return;
            this.handleStartListening()
        })
    }

    handleStartListening = () => {
        const { isListening } = this.state;

        if (window.electron && window.electron.remoteControl) {
            if (isListening) {
                this.setState({ isListening: false });
                window.electron.remoteControl.unsubscribeEvents();
                window.electron.remoteControl.close();
            } else {
                this.setState({ isListening: true, errorMessage: '' });
                console.log('Opening remote control', window.electron.remoteControl.open);
                window.electron.remoteControl.open();

                window.electron.remoteControl.subscribeEvents((data) => {
                    console.log('Received data:', data, this.state.clickerType);

                    if (data.payload.id && this.state.clickerType === 'TEACHER_CLICKER_SEARCH') {
                        console.log('teacher search')
                        this.setState({ teacherDeviceMacId: data.payload.id })
                        this.onClickGo(data.payload, 'TEACHER_CLICKER_SEARCH')
                    } else {
                        this.setState({ studentDeviceMacId: data.payload.id })
                        this.onClickGo(data.payload, 'STUDENT_CLICKER_SEARCH')
                    }


                });
            }
            window.electron.ipcRenderer.once('ipc-example', (arg) => {
                // eslint-disable-next-line no-console
                console.log(arg);
            });
            window.electron.ipcRenderer.send('ipc-example', ['ping']);
        }

    };

    renderClickerInfo(clickerInfo) {

        return (
            <div id="table-scoll" className="table-responsive">
                <table className="table cw-table mb-0 align-items-center">
                    <thead>
                        <tr>
                            <th className="th-left-radius">School Name</th>
                            <th>Set Name</th>
                            <th>Roll Number</th>
                            <th>Device MAC ID</th>
                            <th>Battery</th>
                            <th className="th-right-radius">Tested</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {
                            clickerInfo.map(item => (
                                <>
                                    {
                                        item.studentClickerList.length ? item.studentClickerList.map(clicker => (
                                            <tr key={Math.random()}>
                                                <td>{item.schoolName}</td>
                                                <td>{item.setName}</td>
                                                <td>{clicker.rollNumber}</td>
                                                <td>{clicker.deviceMacId}</td>
                                                <td>{clicker.voltage}</td>
                                                <td>{clicker.testedAllKeys ? "✅" : "❌"}</td>
                                            </tr>
                                        ))
                                            :
                                            <tr className="bg-white pt-4"><td colSpan="5" align='center'>No Records found</td></tr>
                                    }
                                </>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    renderStudentClickerInfo() {
        return (
            <div>
                {
                    this.state.clickerInfo.length ?
                        this.renderClickerInfo(this.state.clickerInfo)
                        :
                        <>No Clicker information Found</>
                }
            </div>
        )
    }

    renderTeacherClickerInfo() {
        return (
            <div>
                {
                    this.state.clickerInfo.length ?
                        this.renderTeacherClicker(this.state.clickerInfo)
                        :
                        <>No Clicker information Found</>
                }
            </div>
        )
    }

    renderTeacherClicker(clickerInfo) {

        return (
            <div id="table-scoll" className="table-responsive">
                <table className="table cw-table mb-0 align-items-center">
                    <thead>
                        <tr>
                            <th className="th-left-radius">School Name</th>
                            <th>Set Name</th>
                            <th>Roll Number</th>
                            <th>Device MAC ID</th>
                            <th>Battery</th>
                            <th className="th-right-radius">Tested</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {
                            clickerInfo.map(item => (
                                <>
                                    {
                                        item.teacherClickerId?.voltage ? <>
                                            <tr key={Math.random()}>
                                                <td>{item.schoolName}</td>
                                                <td>{item.setName}</td>
                                                <td>{item.teacherClickerId.rollNumber}</td>
                                                <td>{item.teacherClickerId.deviceMacId}</td>
                                                <td>{item.teacherClickerId.voltage}</td>
                                                <td>{item.teacherClickerId.testedAllKeys ? "✅" : "❌"}</td>
                                            </tr>
                                        </>
                                            :
                                            <tr className="bg-white pt-4"><td colSpan="5" align='center'>No Records found</td></tr>
                                    }
                                </>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    onClickBack() {
        return window.location.hash = '#/school/dashboard'
    }


    render() {

        if (this.state.showAddClickerSet) {
            return <AddClickerSet delegate={this} />
        }

        if (this.state.showAddClickerId) {
            return <AddClickerId delegate={this}
                schoolName={this.state.selectedSchoolName}
                selectedSchoolId={this.state.selectedSchoolId}
                selectedSet={this.state.selectedSet} />
        }


        return (
            <div className="clicker-list">

                <div className='student-list'>
                    {this.state.showBackButton || Constants.ELECTRON_BUILD ? <img className='report-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={this.onClickBack} /> : ''}
                    <div className='header-container'>
                        <div className='row' >
                            <div className='col-3'>
                                <span className='screen-title'>School Clickers List</span>
                            </div>
                            <div className='col-9 text-right'>
                                <span>
                                    <span>
                                        <button className='cw-btn-md d-inline-block cw-btn-primary mr-2' onClick={() => this.onClickAddClickerSet({}, 'CREATE')} data-tip={"Add New Student"}>
                                            ADD / EDIT CLICKER SET
                                        </button>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="filter-header" >
                        <div className="d-inline cursor-pointer" onClick={this.toggleFilters}>
                            <div className="filter-title d-inline">{"Filters"}</div>
                            <div className="d-inline"><i class={this.state.showFilters ? "filter-arrow up" : "filter-arrow down"}></i></div>
                        </div>
                    </div>

                    {
                        !this.state.reload ?
                            <div className={`mt-2 mb-2 ${this.state.showFilters ? 'filter-content' : 'filter-content d-none'}`}>
                                <div className='row pt-4'>
                                    <div className='col-2'>
                                        <div className='filter-input-label pb-2'>School Name / School Code</div>
                                        <input
                                            className='cw-input search-input'
                                            placeholder='Search By Name and Code'
                                            onChange={e => this.onChangeHandler(e, 'search')}
                                            value={this.state.filter?.search}
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <div className='filter-input-label pb-2'>Teacher Clicker Id</div>
                                        <input
                                            className='cw-input search-input'
                                            placeholder='Search Teacher Clicker Id'
                                            onFocus={e => this.setClickerType(e, 'TEACHER_CLICKER_SEARCH')}
                                            onChange={e => this.onChangeDeviceMacHandler(e, 'TEACHER_CLICKER_SEARCH')}
                                            value={this.state.teacherDeviceMacId}
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <div className='filter-input-label pb-2'>Student Clicker Id</div>
                                        <input
                                            className='cw-input search-input'
                                            placeholder='Search Student Clicker Id'
                                            onFocus={e => this.setClickerType(e, 'STUDENT_CLICKER_SEARCH')}
                                            onChange={e => this.onChangeDeviceMacHandler(e, 'STUDENT_CLICKER_SEARCH')}
                                            value={this.state.studentDeviceMacId}
                                        />
                                    </div>
                                    <div className="filter-button  d-inline-block">
                                        <button className={`cw-button`} onClick={() => this.onClickGo()} >{"GO"}</button>
                                    </div>
                                    <div className="filter-button ml-3 d-inline-block">
                                        <button className={`cw-button clear-btn`} onClick={() => this.onClickClear()} >{"CLEAR"}</button>
                                    </div>
                                </div>
                            </div>
                            :
                            <></>
                    }

                    {this.state.isLoading ? <Loading /> : <></>}


                    {
                        !this.state.studentDeviceMacId && !this.state.teacherDeviceMacId ?
                            <div className={`pt-4 mx-4`}>
                                <div id="table-scoll" className="table-responsive mt-5">
                                    <table className="table cw-table mb-0 align-items-center">
                                        <thead>
                                            <tr>
                                                <th className='th-left-radius'>School Name</th>
                                                <th className=''>School Code</th>
                                                <th className=''>No of Sets</th>
                                                <th className=''>Add/Edit Clicker Id to Set </th>
                                                <th className=''>Registration Done</th>
                                                <th className='th-right-radius'>Testing Done</th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white">
                                            {
                                                this.state.schools?.length ? this.state.schools?.map((item, index) => (
                                                    <tr key={item.schoolCode} className={`mt-4 ${this.state.schoolIndex === index ? 'selected-school-bg' : ''}`}>
                                                        <td>{item.name}</td>
                                                        <td>{item?.schoolCode}</td>
                                                        <td>{item?.clicker?.setCount}</td>
                                                        <td>{this.getSetList(item.schoolCode, item.name, index)}</td>
                                                        <td>{this.getSetListForTesting(item.schoolCode, item.name, index)}</td>
                                                        <td>{this.getSetListForTesting(item.schoolCode, item.name, index)}</td>
                                                        {/* <td className=""><span className="continue-button px-5 py-2">{item?.clicker?.allClickerValidationDone ? 'Yes' : 'No'}</span></td> */}
                                                    </tr>
                                                ))
                                                    : <tr className="bg-white pt-4"><td colSpan="5" align='center'>No Records found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className='card-footer'>
                                    {this.state.meta?.totalPages ? (
                                        <PaginationComponent
                                            startIndex={this.startIndex}
                                            selectedPage={this.currentPage}
                                            totalPages={this.state.meta.totalPages}
                                            onPageSelected={this.onPageSelected.bind(this)}
                                        />
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                            :
                            this.state.studentDeviceMacId ?
                                <>
                                    {this.renderStudentClickerInfo()}
                                </>
                                :
                                this.state.teacherDeviceMacId ?
                                    <>
                                        {this.renderTeacherClickerInfo()}
                                    </>
                                    :
                                    <></>
                    }


                </div>
            </div>
        )
    }

}

export default ClickerList;